"use client";

import { ReactNode } from "react";
import { csx } from "../../utils";

import "./Badge.css";

export type BadgeVariant =
  | "primary"
  | "secondary"
  | "transparent"
  | "success"
  | "warning"
  | "danger";

export const BadgeVariants: Record<BadgeVariant, BadgeVariant> = {
  primary: "primary",
  secondary: "secondary",
  transparent: "transparent",
  success: "success",
  warning: "warning",
  danger: "danger",
};

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * The content to display within the badge.
   */
  children: ReactNode;
  /**
   * The badge's visual aesthetic.
   * - type {@link BadgeVariant}
   */
  variant?: BadgeVariant;
}

/**
 * A badge component for displaying status, categories, or counts with various visual styles.
 *
 * API:
 *  - {@link BadgeProps}
 *  - extends {@link React.HTMLAttributes}
 */
export const Badge = ({ variant, children, ...props }: BadgeProps) => {
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid={props["data-testid"]}
      className={csx("proton-Badge", variant && `proton-Badge--${variant}`)}
    >
      {children}
    </div>
  );
};
